import { useEffect, useState } from 'react';
import TemplateMemory from './TemplateMemory';
import GlobalPreferences from './GlobalPreferences';
import { Divider } from 'antd';
import { MemoryFeatureFlag } from './FeatureFlag';

const Memory = () => {
  return (
    <div className="settings-component page-wrapper">
      <div className="settings-component flex flex-col p-5 shadow-xl w-full md:w-[75%] bg-white rounded-xl">
        <div className="w-full flex justify-end">
          <MemoryFeatureFlag />
        </div>
        <div className="w-full">
          <GlobalPreferences />
        </div>
        <Divider />
        <div className="w-full">
          <TemplateMemory />
        </div>
      </div>
    </div>
  );
};

export default Memory;
